import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AppStateService } from "../services/app-state.service";


@Injectable()
export class JudgeGuard  {

  constructor(private router: Router, private appState: AppStateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.appState.user && this.appState.user.firstName && this.appState.user.jobTitle == "Essay Judge") {
      return true;
    } else {
      this.router.navigate(["/public/login"], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
